import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BuyingInfluence } from '../api/models';
import { State } from '../store/interfaces';
import {
  loadBuyingInfluenceErrorAction,
  loadBuyingInfluenceRequestAction,
  loadBuyingInfluenceSuccessAction,
} from '../store/reducers/buyingInfluence';
import { StatusCodes } from 'http-status-codes';
import { BuyingInfluenceService } from '../api';

export const useBuyingInfluence = (
  buyingInfluenceService: BuyingInfluenceService
) => {
  const intent = useSelector((state: State) => state.buyingInfluence);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadBuyingInfluence = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadBuyingInfluenceRequestAction());
    try {
      const response = await buyingInfluenceService.loadAllBuyingInfluence();

      return dispatch(loadBuyingInfluenceSuccessAction(response));
    } catch (error) {
      return dispatch(loadBuyingInfluenceErrorAction());
    }
  };

  const createBuyingInfluence = async (
    data: BuyingInfluence,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await buyingInfluenceService.createBuyingInfluence({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  const updateBuyingInfluence = async (
    data: BuyingInfluence,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await buyingInfluenceService.updateBuyingInfluence(
        data,
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  return {
    loadBuyingInfluence,
    createBuyingInfluence,
    updateBuyingInfluence,
    updating,
    updateError,
  };
};
